<template>
  <div class="container d-flex fd-column SECTION">
    <div class="h3 text-bold text-center p-x-1:mo p-b-2">
      <div>{{content.title}}</div>
    </div>
    <div class="TESTIMONIAL-SECTION" >
      <vk-carousel  class="d-flex fd-column" ref="testimonialsCarousel" arrows-hidden>
        <div
            class="w-100"
            v-for="(testimonial, index) in content.testimonials"
            :key="index+'testimonial'"
        >
          <div class="ITEM">
            <p class="text-italic p-b-3">{{testimonial.quote}}</p>
            <div class="LINE"></div>
            <div class="p-t-2">{{testimonial.name}}</div>
          </div>
        </div>
      </vk-carousel>
      <div class="NAV-CONTAINER">
        <div
            class="NAV-DOT"
            v-for="(testimonial, index) in content.testimonials"
            :key="index+'-DOT'"
            :class="{ 'ACTIVE': index === activeIndex }"
            @click="onDotSelect(index)"
        >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name: 'pro-short-testimonials',
  components: {
  },
  data () {
    return {
      activeIndex: 0,
      intervalId: null,
    };
  },
  computed: {
    ...mapGetters('homepage/contentful', [
      'proHomePage',
    ]),
    content () {
      return this.proHomePage.testimonialSection;
    },
    services () {
      return this.content.testimonials[this.activeIndex].services.join(' | ');
    },
  },
  mounted () {
    this.advanceSlider();
  },
  beforeDestroy () {
    clearInterval(this.intervalId);
  },
  methods: {
    onDotSelect (index) {
      clearInterval(this.intervalId);
      this.intervalId = null;
      this.activeIndex = index;
      this.$refs.testimonialsCarousel.scrollToIndex(this.activeIndex);
      this.advanceSlider();
    },
    advanceSlider () {
      this.intervalId = setInterval(() => {
        this.activeIndex = (this.activeIndex + 1) % this.content.testimonials.length;
        this.$refs.testimonialsCarousel.scrollToIndex(this.activeIndex);
      }, 5000);
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@homeservices/design-kit/tools";
.SECTION {
  margin: 10 * $unit auto;
}
.TESTIMONIAL-SECTION {
  display: flex;
  flex-direction: column;
  overflow: scroll;
  background-color: $color-gray20;
}
.NAV-CONTAINER {
  padding: 6px 10px;
  margin-bottom: 40px ;
  max-width:auto;
  align-self: center;
  display: flex;
  background-color: white;
}
.NAV-BOX {
  padding:8px 10px ;
  display: flex;
  background-color: white;
}
.NAV-DOT {
  height: 10px;
  width: 10px;
  border-radius: 100px;
  background-color: $color-gray50;
  margin-right: 10px;
}
.ACTIVE {
    background-color: $color-depot;
}
.NAV-DOT:nth-last-child(1){
  margin-right: 0px;
}
.ITEM {
overflow: hidden;
background-color: $color-gray20;
padding: 2 *$unit;
}
.LINE {
  width: 33%;
  border-bottom: solid 2px $color-depot;
}
</style>
